import React from 'react'
import { InfoWindow, Marker, } from '@react-google-maps/api'
import PropTypes from 'prop-types'

import MarkerInfoWindow from './MarkerInfoWindow'
import { getMarkerColorForAddrType, getMarkerUrl, inGreaterWA, } from '../../util/mapCalcs'

const ProgramMapMarker = ({
  activateProgram = null,
  address = '',
  desc = '',
  lat = null,
  lng = null,
  name = '',
  progOccId = null,
  programType = null,
  title = '',
  type = null,
  viewUrl = null,
}) => {
  const [ infoOpen, setInfoOpen, ] = React.useState(false)

  const closeClick = React.useCallback((e) => {
    if (e) {
      e.preventDefault()
    }
    setInfoOpen(false)
  }, [])

  const openClick = React.useCallback(() => {
    setInfoOpen(!infoOpen)
  }, [ infoOpen, ])

  const typeColor = getMarkerColorForAddrType(type)
  const url = getMarkerUrl(programType.toLowerCase(), type.toLowerCase())
  let icon = React.useMemo(() => {
    let ico = null
    try {
      ico = {
        fillColor     : typeColor,
        fillOpacity   : 1,
        //scale         : 500, // todo: pass zoom level from hoc to scale
        scaledSize    : new google.maps.Size(25, 25), // eslint-disable-line no-undef
        strokeColor   : 'white',
        strokeOpacity : 1,
        strokeWeight  : 2,
        url           : url,
      }
    } catch {
      console.warn('Unable to create marker, map lib not ready.')
    }
    return ico
  }, [ typeColor, url, ])

  const latLng = React.useMemo(() => ({ lat, lng, }), [ lat, lng, ])
  let inbounds
  try {
    inbounds = inGreaterWA(latLng)
  } catch {
    inbounds = false
  }

  if (!lat || !lng) {
    // If we don't have a lat or a lng show nothing
    return null
  } else if (lat < 23 || lat > 52 || lng < -130 || lng > -80 || !inbounds) {
    // WCOD-295: Locations outside continental US & southern Canada will not display
    // This should be done at a higher level.
    return null
  }

  return (
    <Marker 
      aria-label={type}
      class={'marker'}
      icon={icon}
      onClick={openClick}
      position={latLng}
    >
      { infoOpen && (
        <InfoWindow onCloseClick={closeClick}>
          <MarkerInfoWindow 
            activateProgram={activateProgram}
            address={address}
            description={desc}
            name={name}
            progOccId={progOccId}
            programType={programType}
            title={title}
            type={type}
            viewUrl={viewUrl}
          />
        </InfoWindow>
      )}
    </Marker>
  )
}

ProgramMapMarker.propTypes = {
  activateProgram : PropTypes.func,
  address         : PropTypes.string,
  desc            : PropTypes.string,
  lat             : PropTypes.oneOfType([ PropTypes.string, PropTypes.number , ]),
  lng             : PropTypes.oneOfType([ PropTypes.string, PropTypes.number , ]),
  name            : PropTypes.string,
  progOccId       : PropTypes.oneOfType([ PropTypes.string, PropTypes.number , ]),
  programType     : PropTypes.string,
  title           : PropTypes.string,
  type            : PropTypes.string,
  viewUrl         : PropTypes.string,
}

export default React.memo(ProgramMapMarker)